"use strict";

module.exports = {
  title: '任务成长系统',
  /**
   * 是否系统布局配置
   */
  showSettings: false,
  /**
   * 是否显示 tagsView
   */
  tagsView: false,
  /**
   * 是否固定头部
   */
  fixedHeader: true,
  /**
   * 是否显示logo
   */
  sidebarLogo: true,
  /**
   * @type {string | array} 'production' | ['production', 'development']
   * @description Need show err logs component.
   * The default is only used in the production env
   * If you want to also use it in dev, you can pass ['production', 'development']
   */
  errorLog: 'production'
};